import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'decodeWhitespace' })
export class DecodeWhitespacePipe implements PipeTransform {

  public transform(value: string): string {
    return value?.replace(/\\r\\n|\\r|\\n/g, '\r\n');
  }
}
